import React from "react";

import { ReactComponent as LeftArrow } from "../../../../assets/appearencePage/arrow-left.svg";
import { ReactComponent as LeftArrowDark } from "../../../../assets/appearencePage/arrow-left-dark.svg";
import { ReactComponent as SeoSvgBw } from "../../../../assets/appearencePage/search-normal.svg";
import { ReactComponent as SeoSvgBwDark } from "../../../../assets/appearencePage/search-normal-dark.svg";

import { Link } from "react-router-dom";
import { SeoAcc } from "../../largeScreen/appearance/accordions";
import { useSelector } from "react-redux";

const Seo = () => {
  const { darkMode } = useSelector((state) => state.theme);
  return (
    <div className="px-6">
      <div className="md:hidden mt-10 mb-10 ">
        <Link className="flex items-center gap-3" to={"/dashboard/appearance"}>
          <div className=" flex items-center justify-center">
            {darkMode ? <LeftArrowDark /> : <LeftArrow />}
          </div>
          <h6 className="w-full text-body_copy2 dark:text-color_v1_dark">
            SEO
          </h6>
        </Link>
      </div>
      <div
        className={`dark:border-color_dark bg-light_bg_v5 dark:bg-dark-secondary dark:text-color_v1_dark rounded-[10px] border border-light_bg_v2 p-6 mb-10`}
      >
        <div className="flex gap-2.5 justify-between items-center cursor-pointer">
          <div>
            {darkMode ? <SeoSvgBwDark height={20} width={20} /> : <SeoSvgBw height={20} width={20} />}
          </div>

          <div className="text-small2_b text-heading_color w-full dark:text-color_v1_dark">
            <h1>SEO</h1>
          </div>
        </div>
        <SeoAcc />
      </div>
    </div>
  );
};

export default Seo;
